import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import ProtectedRoute from "components/ProtectedRoute";
import NotFound from "pages/NotFound";
import HomeLanding from './pages/home-landing';
import SubscriptionPayment from './pages/subscription-payment';
import RegistrationLogin from './pages/registration-login';
import ProfileCreation from './pages/profile-creation';
import UserProfileSettings from './pages/user-profile-settings';
import SearchDiscovery from './pages/search-discovery';
import MessagingSystem from './pages/messaging-system';
import MemberDashboard from './pages/member-dashboard';
import AdminPanel from './pages/admin-panel';
import SafetyTrustCenter from './pages/safety-trust-center';
import HowItWorksPage from './pages/how-it-works';
import UroPayEmbedPage from './pages/subscription-payment/UroPayEmbedPage';
import UroPaySuccessPage from './pages/subscription-payment/UroPaySuccessPage';
import UroPayCancelPage from './pages/subscription-payment/UroPayCancelPage';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Public routes */}
        <Route path="/" element={<HomeLanding />} />
        <Route path="/home-landing" element={<HomeLanding />} />
        <Route path="/registration-login" element={<RegistrationLogin />} />
        <Route path="/how-it-works" element={<HowItWorksPage />} />
        
        {/* Protected routes */}
        <Route path="/subscription-payment" element={
          <ProtectedRoute>
            <SubscriptionPayment />
          </ProtectedRoute>
        } />
        <Route path="/subscription-payment/uropay-embed" element={
          <ProtectedRoute>
            <UroPayEmbedPage />
          </ProtectedRoute>
        } />
        <Route path="/subscription-payment/uropay-success" element={
          <ProtectedRoute>
            <UroPaySuccessPage />
          </ProtectedRoute>
        } />
        <Route path="/subscription-payment/uropay-cancel" element={
          <ProtectedRoute>
            <UroPayCancelPage />
          </ProtectedRoute>
        } />
        {/* UroPay return URLs (match merchant dashboard / embed snippet paths) */}
        <Route path="/payment/uropay-success" element={
          <ProtectedRoute>
            <UroPaySuccessPage />
          </ProtectedRoute>
        } />
        <Route path="/payment/uropay-cancel" element={
          <ProtectedRoute>
            <UroPayCancelPage />
          </ProtectedRoute>
        } />
        <Route path="/profile-creation" element={
          <ProtectedRoute>
            <ProfileCreation />
          </ProtectedRoute>
        } />
        <Route path="/user-profile-settings" element={
          <ProtectedRoute>
            <UserProfileSettings />
          </ProtectedRoute>
        } />
        <Route path="/search-discovery" element={
          <ProtectedRoute requiredSubscription={true}>
            <SearchDiscovery />
          </ProtectedRoute>
        } />
        <Route path="/messaging-system" element={
          <ProtectedRoute requiredSubscription={true}>
            <MessagingSystem />
          </ProtectedRoute>
        } />
        <Route path="/member-dashboard" element={
          <ProtectedRoute requiredSubscription={true}>
            <MemberDashboard />
          </ProtectedRoute>
        } />
        <Route path="/admin-panel" element={
          <ProtectedRoute>
            <AdminPanel />
          </ProtectedRoute>
        } />
        <Route path="/safety-trust-center" element={
          <ProtectedRoute>
            <SafetyTrustCenter />
          </ProtectedRoute>
        } />
        
        {/* 404 */}
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
